import { defineStore } from 'pinia'
import { ref } from 'vue'

const ACCESS_TOKEN_KEY = 'zp_access_token'
const ACCESS_EXPIRES_AT_KEY = 'zp_access_expires_at'
const USER_INFO_KEY = 'zp_user_info'

function readSessionValue(key) {
  try {
    return window.sessionStorage.getItem(key)
  } catch (error) {
    return null
  }
}

function writeSessionValue(key, value) {
  try {
    window.sessionStorage.setItem(key, value)
  } catch (error) {
    // ignore
  }
}

function removeSessionValue(key) {
  try {
    window.sessionStorage.removeItem(key)
  } catch (error) {
    // ignore
  }
}

export const useSessionStore = defineStore('session', () => {
  const now = Date.now()
  const persistedToken = readSessionValue(ACCESS_TOKEN_KEY) || ''
  const persistedExpiresAt = Number.parseInt(readSessionValue(ACCESS_EXPIRES_AT_KEY) || '0', 10)

  let persistedUser = null
  const rawUser = readSessionValue(USER_INFO_KEY)
  if (rawUser) {
    try {
      persistedUser = JSON.parse(rawUser)
    } catch (error) {
      persistedUser = null
    }
  }

  const validToken = persistedToken && Number.isFinite(persistedExpiresAt) && persistedExpiresAt > now
  const accessToken = ref(validToken ? persistedToken : '')
  const accessExpiresAt = ref(validToken ? persistedExpiresAt : 0)
  const userInfo = ref(validToken ? persistedUser : null)

  const setAccessToken = (token, expiresInSeconds = 600) => {
    accessToken.value = token || ''
    accessExpiresAt.value = Date.now() + expiresInSeconds * 1000
    if (accessToken.value) {
      writeSessionValue(ACCESS_TOKEN_KEY, accessToken.value)
      writeSessionValue(ACCESS_EXPIRES_AT_KEY, String(accessExpiresAt.value))
    } else {
      removeSessionValue(ACCESS_TOKEN_KEY)
      removeSessionValue(ACCESS_EXPIRES_AT_KEY)
    }
  }

  const setUserInfo = (user) => {
    userInfo.value = user || null
    if (userInfo.value) {
      writeSessionValue(USER_INFO_KEY, JSON.stringify(userInfo.value))
    } else {
      removeSessionValue(USER_INFO_KEY)
    }
  }

  const clearSession = () => {
    accessToken.value = ''
    accessExpiresAt.value = 0
    userInfo.value = null
    removeSessionValue(ACCESS_TOKEN_KEY)
    removeSessionValue(ACCESS_EXPIRES_AT_KEY)
    removeSessionValue(USER_INFO_KEY)
  }

  return {
    accessToken,
    accessExpiresAt,
    userInfo,
    setAccessToken,
    setUserInfo,
    clearSession
  }
})
